import CheckBoxListFilter from "./CheckBoxListFilter";
import PriceFilter from "./PriceFilter";
import QueryFilter from "./QueryFilter";
import RatingFilter from "./RatingFilter";
import TimeScheduleFilter from "./TimeScheduleFilter";
import TimeSliderFilter from "./TimeSliderFilter";
import type { FilterComponent, FilterValueMap } from "../filter.types";

/**
 * Default registry of filter components.
 *
 * - Used as the default in the Filters component.
 * - Consumers can override by passing their own registry via the `components` prop to Filters.
 * - This pattern follows the Open/Closed Principle (SOLID): open for extension, closed for modification.
 * - Example usage:
 *   import { filtersComponent } from "@/shared/components/filters/components";
 *   <Filters filters={filters} components={filtersComponent} ... />
 * - To override, provide your own registry with the same type signature.
 */
export const filtersComponent: {
  [K in keyof FilterValueMap]: FilterComponent<FilterValueMap[K]>;
} = {
  price: PriceFilter,
  stars: RatingFilter,
  query: QueryFilter,
  time: TimeSliderFilter,
  airline: CheckBoxListFilter,
  cabinType: CheckBoxListFilter,
  type: CheckBoxListFilter,
  arrivalTime: TimeScheduleFilter,
  departureTime: TimeScheduleFilter,
  classes: CheckBoxListFilter,
};
